import { get } from "../../config/api";

export const ExchangeRate = {
  getTomanPrice: () => get(`exchangerates/latest?from=TL&to=IRT`),
};
